import './style.scss';

export default !function () {
  const block = document.querySelector('.resume');

  if (!block) {
    return;
  }

  const skillsList = block.querySelector('.resume__skills');
  const skills = skillsList.querySelectorAll('.resume__skill');
  const moreButton = block.querySelector('.resume__more-skills');
  const moreButtonText = moreButton.querySelector('span');

  if (skills.length <= 5) {
    moreButton.remove();
  } else {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const tablet = window.matchMedia('(min-width: 768px)');

    let skillsListHeight;
    let visibleSkillsHeight;

    const calculateVisibleSkillsHeight = () => {
      visibleSkillsHeight = 0;

      skills.forEach((skill, i) => {
        const margin = 14;
        let skillHeight;

        if (i <= 3) {
          skillHeight = skill.getBoundingClientRect().height + margin;
        } else if (i === 4) {
          skillHeight = skill.getBoundingClientRect().height;
        } else {
          skillHeight = 0;
        }

        visibleSkillsHeight += skillHeight;
      });
    }

    const setSkillsListHeight = () => {
      skillsList.removeAttribute('style');
      skillsListHeight = skillsList.getBoundingClientRect().height;

      calculateVisibleSkillsHeight();
      skillsList.style.maxHeight = `${visibleSkillsHeight}px`;
    }

    const toggleHandler = () => {
      skillsList.style.maxHeight === `${skillsListHeight}px`
        ? skillsList.style.maxHeight = `${visibleSkillsHeight}px`
        : skillsList.style.maxHeight = `${skillsListHeight}px`;

      moreButton.classList.toggle('resume__more-skills--open');

      if (moreButton.classList.contains('resume__more-skills--open')) {
        moreButtonText.textContent = 'Скрыть навыки';
      } else {
        moreButtonText.textContent = 'Все навыки';
      }
    }

    if (!desktop.matches) {
      setSkillsListHeight();

      moreButton.addEventListener('click', toggleHandler);
    }

    const desktopMediaChangeListener = () => {
      if (desktop.matches) {
        moreButton.removeEventListener('click', toggleHandler);
        skillsList.removeAttribute('style');
      } else {
        setSkillsListHeight();

        moreButton.addEventListener('click', toggleHandler);
      }
    }

    const tabletMediaChangeListener = () => {
      if (!desktop.matches) {
        setSkillsListHeight();
        moreButton.classList.remove('resume__more-skills--open');
      }
    }

    tabletMediaChangeListener();
    desktopMediaChangeListener();

    tablet.addEventListener('change', tabletMediaChangeListener);
    desktop.addEventListener('change', desktopMediaChangeListener);
  }

  // analytics
  block.addEventListener('click', (evt) => {
    const target = evt.target;

    if (!target || !target.dataset.analytics) {
      return;
    }

    switch (target.dataset.analytics) {
      case 'instrument':
        window.$analytics && window.$analytics.push('resume-click-instrument', {
          instrument: target.dataset.instrument
        });
        break;

      case 'certificate':
        window.$analytics && window.$analytics.push('resume-click-certificate')
        break;
    }
  })
}();
